export default __webpack_public_path__ + "static/media/water1.c017ae82.png";